export default "__VITE_ASSET__BEXByQwn__"